// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css';
//   "getSurvey transforms reviews into community polls, turning feedback into clear insights and enabling businesses to respond with real-time deals and offers."

export default function Footer({ showUserGuide = true, showBetaNotice = true }) {
  return (
    <footer className="footer">
      <p className="footer-disclaimer">
        <a href="/about">About</a>
        {' '}· <a href="/disclaimer">Disclaimer &amp; Responsible Use Policy</a>
        {showUserGuide && <> · <a href="/guide">User Guide</a></>}
        {' '}· <a href="/privacy/anonymous-id">ID Policy</a>
        {' '}· <a href="/privacy">Privacy Policy</a>
        {' '}· <a href="mailto:supports@getsurvey.app">Report Content</a>
        {showBetaNotice && (
          <>
            <br />
            Beta: AI results may be inaccurate or inappropriate. Do not include sensitive data.
          </>
        )}
      </p>
      <p className="footer-copy">© {new Date().getFullYear()} getSurvey. All rights reserved.</p>
    </footer>
  );
}
